import React from "react"
import { createContext } from "use-context-selector"

import {useAppContextState} from "../../@hooks"


const Context = createContext({})

const initialState = { currency: null }

export function AppCurrencyProvider({children}) {
    const { state, replaceState, resetState, updateState } = useAppContextState(initialState)


    return <Context.Provider value={{state, replaceState, resetState, updateState}}>
        {children}
    </Context.Provider>
}
export default Context